/**
 * Configuration for the changelog feature.
 *
 * The passkey is intentionally hardcoded here (per product requirement) and is
 * therefore "security by obscurity" only — it ships in the client bundle so the
 * editor can gate itself before any network call. To rotate it for everyone with
 * a single knob, set `NEXT_PUBLIC_CHANGELOG_PASSKEY` (inlined into the client and
 * also honoured by the server). A server-only `CHANGELOG_PASSKEY` still wins on
 * the write path if you want the server stricter than the client.
 */

const DEFAULT_CHANGELOG_PASSKEY = "utx-changelog-2026";

/** Editor passkey the client gates on (rotate with `NEXT_PUBLIC_CHANGELOG_PASSKEY`). */
export const CHANGELOG_PASSKEY =
	process.env.NEXT_PUBLIC_CHANGELOG_PASSKEY ?? DEFAULT_CHANGELOG_PASSKEY;

/** Header carrying the passkey on edit requests. */
export const CHANGELOG_KEY_HEADER = "x-changelog-key";

/** Path (relative to the project root) of the committed source of truth. */
export const CHANGELOG_DATA_PATH = "src/data/changelog.json";

/** Mantine hotkey opening the read-only viewer (everyone). */
export const CHANGELOG_HOTKEY_VIEW = "mod+shift+L";

/** Mantine hotkey opening the editor (gated by the passkey). */
export const CHANGELOG_HOTKEY_EDIT = "mod+shift+E";

/** localStorage key remembering a validated passkey for this browser. */
export const CHANGELOG_PASSKEY_STORAGE = "changelog-editor-key";
